var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8457_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 28.3333H6.66667C6.22464 28.3333 5.80072 28.1577 5.48816 27.8452C5.17559 27.5326 5 27.1087 5 26.6667V6.66667C5 6.22464 5.17559 5.80072 5.48816 5.48816C5.80072 5.17559 6.22464 5 6.66667 5H33.3333C33.7754 5 34.1993 5.17559 34.5118 5.48816C34.8244 5.80072 35 6.22464 35 6.66667V18.3333",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21.667H20",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 35H19.1668",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 28.333L15.8335 34.9997",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 36.667L35.5832 31.1937C35.9256 30.8614 36.1979 30.464 36.3842 30.0247C36.5704 29.5855 36.6668 29.1134 36.6676 28.6363C36.6683 28.1592 36.5735 27.6868 36.3887 27.2469C36.2039 26.8071 35.9328 26.4087 35.5915 26.0753C34.8951 25.3942 33.9602 25.012 32.9861 25.0102C32.0119 25.0083 31.0756 25.3869 30.3765 26.0653L30.0032 26.432L29.6315 26.0653C28.9352 25.3847 28.0006 25.0029 27.0269 25.001C26.0532 24.9991 25.1172 25.3774 24.4182 26.0553C24.0757 26.3875 23.8032 26.7849 23.6168 27.2241C23.4305 27.6632 23.3339 28.1353 23.333 28.6124C23.3321 29.0895 23.4267 29.5619 23.6114 30.0019C23.7961 30.4418 24.067 30.8402 24.4082 31.1737L29.9999 36.667Z",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8457_899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.22a93650117a43be7f1a36af75ea74a4.svg";
export { ForwardRef as ReactComponent };